const REDEEM = {
  title: {
    text: "Order Authorised",
    dataAid: "title",
  },
  subtitle: {
    text: "Your Redemption request has been authorised successfully. You will receive a mail once it is processed",
    dataAid: "subtitle",
  },
};

const SWITCH = {
  title: {
    text: "Switch request placed",
    dataAid: "title",
  },
  subtitle: {
    text: "Funds will reflect in your portfolio once the units are switched successfully",
    dataAid: "subtitle",
  },
};

const SWP = {
  title: {
    text: "Order Authorised",
    dataAid: "title",
  },
  subtitle: {
    text: "Your SWP request has been authorised successfully. You will receive a mail once it is processed",
    dataAid: "subtitle",
  },
};

const STP = {
  title: {
    text: "Order Authorised",
    dataAid: "title",
  },
  subtitle: {
    text: "Your STP request has been authorised successfully. You will receive a mail once it is processed",
    dataAid: "subtitle",
  },
};

const ORDER_SUCCESS = {
  dataAid: "orderAuthorised",
  navigationHeader: {
    dataAid: "1",
  },
  landingHeader: {
    dataAid: "successScreenData"
  },
  redeem: REDEEM,
  switch: SWITCH,
  swp : SWP,
  stp: STP
}

export default ORDER_SUCCESS;
